<template>
  <div class="search">
    <div class="menu">
      <menu-list></menu-list>
    </div>
    <p class="search-text">
      共{{total}}条
      <span>{{searchText}}</span>
      相关的搜索结果
    </p>
    <div class="data-view" >
      <ul v-if="dataList.length > 0">
        <li v-for="(item, index) in dataList" :key="index">
          <div class="left" @click="go(item.id)">
            <img :src="item.imgUrl" alt="">
          </div>
          <div class="middle">
            <p class="p-name" v-html="item.name"></p>
            <p class="p-money">
              ￥{{item.price ? item.price : item.money}}
              <span v-show="item.price ? true : false">
                定价：￥{{item.money}}
              </span>
            </p>
            <p class="p-eBookPrice" v-show="item.eBookPrice">
              电子书:￥
              {{item.eBookPrice}}
              </p>
            <p class="p-eBookPrice" v-html="item.author"></p>
            <el-rate
              class="star"
              v-model="item.star"
              disabled
              show-score
              text-color="red"
              score-template="{value}颗星">
            </el-rate>
            <div class="d-describe" v-html="item.describe"></div>
          </div>
          <div class="right">
            <div class="btns">
              <img @click="collection(item)" :src="item.isSc ? star2 : star1" alt="">
              <img
                @click="shoppingCart(item)"
                :src="item.isGwc ? gwc2 : gwc1"
                alt=""
                :class="item.isGwc ? 'imgActive' : ''">
              <button @click="trialReading(item)">在线试读</button>
            </div>
          </div>
        </li>
      </ul>
      <div class="no-data" v-show="dataList.length === 0">
        <p class="p1">
          抱歉，没找到
          <span>
            "{{searchText}}"
          </span>
          相关的图书！
        </p>
        <p class="p2">您可以使用多个关键词搜索。</p>
      </div>
      <div class="pagination">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          layout="prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import Menu from '@/base/menu/menu'
export default {
  name: '',
  components: {
    'menu-list': Menu
  },
  data () {
    return {
      gwc1: require('@/assets/images/fl/gwc1.png'),
      gwc2: require('@/assets/images/fl/gwc2.png'),
      star1: require('@/assets/images/fl/star1.png'),
      star2: require('@/assets/images/fl/star2.png'),
      num: 0,
      searchText: '',
      dataList: [],
      show: false,
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  methods: {
    trialReading (item) { // 在线试读
      if (item.eBookPrice) {
        let routeData = this.$router.resolve({
          name: 'Book',
          query: {
            bookId: item.id,
            type: 1
          }
        })
        window.open(routeData.href, '_blank')
        // window.open('http://localhost:8080/#/book?bookId=' + `${item.id}&type=1`)
      } else {
        alert('该书籍没有电子书')
      }
    },
    shoppingCart (item) { // 购物车
      const state = item.isGwc
      const userId = this.$store.state.userMsg.id
      if (!userId) {
        this.$router.push({
          name: 'Login'
        })
      } else {
        if (!state) {
          const bookId = item.id
          const par = `?bookId=${bookId}&userId=${userId}&type=0`
          const bookPrice = item.eBookPrice
          this.$get(this.$allUrl.addCart + par).then(res => {
            if (res.code === '0') {
              this.$message({
                message: '添加成功',
                type: 'success'
              })
              item.isGwc = true
            } else {
              this.$message.error('添加失败')
            }
          })
          if (bookPrice) {
            const par2 = `?bookId=${bookId}&userId=${userId}&type=1`
            this.$get(this.$allUrl.addCart + par2).then(res => {
              if (res.code !== '0') {
                this.$message.error('电子书加入购物车失败')
              }
            })
          }
        }
      }
    },
    collection (item) { // 收藏
      const userId = this.$store.state.userMsg.id
      if (!userId) {
        this.$router.push({
          name: 'Login'
        })
      } else {
        if (!item.isSc) {
          const bookId = item.id
          const par = `?bookId=${bookId}&userId=${userId}`
          this.$get(this.$allUrl.addFavorite + par).then(res => {
            if (res.code === '0') {
              this.$notify({
                title: '成功',
                message: '已成功收藏',
                type: 'success',
                showClose: false,
                duration: 1500
              })
              item.isSc = true
            } else {
              this.$message.error(res.message)
            }
          })
        }
      }
    },
    handleCurrentChange (val) { // 分页
      const start = (val - 1) * this.pageSize
      this.searchVal(start)
    },
    searchVal (start) {
      const val = this.$route.query.text
      const self = this
      if (val) {
        this.searchText = val
        const userId = this.$store.state.userMsg.id
        const pageSize = this.pageSize
        const par = userId ? `?start=${start}&num=${pageSize}&searchWords=${val}&userId=${userId}` : `?start=${start}&num=${pageSize}&searchWords=${val}`
        this.$get(this.$allUrl.searchBooks + par).then(res => {
          if (res.code === '0') {
            this.total = res.recordsTotal
            const list = res.data
            const imgAdmin = this.$allUrl.imgAdmin
            self.dataList = []
            list.forEach(e => {
              self.dataList.push({
                id: e.bookId,
                imgUrl: imgAdmin + e.coverUrl,
                name: e.bookName,
                money: e.paperPrice,
                price: e.promotionPrice,
                eBookPrice: e.emark === 0 ? '' : e.bookPrice,
                author: e.bookAuthors,
                star: e.starLevel,
                describe: e.bookSummary,
                isGwc: false,
                isSc: e.favorite !== null
              })
            })
          }
        })
      }
    },
    go (id) {
      this.$router.push({
        name: 'GoodsDetails',
        query: {
          id: id
        }
      })
    }
  },
  mounted () {
    this.searchVal(0)
  },
  watch: {
    '$route' () {
      this.searchVal(0)
    }
  }
}
</script>
<style lang="less" scoped>
  .search{
    .pagination{
      text-align: right;
      padding: 50px 0;
    }
    .menu{
      margin: 20px auto;
      width: 600px;
    }
    .search-text{
      color: #666666;
      font-size: 14px;
      padding: 0 10px;
      span{
        color: red;
      }
    }
    .data-view{
      background-color: #F6F6F6;
      padding: 0 30px;
      ul{
        list-style: none;
        padding: 0;
        margin: 0;
        li{
          border-bottom: 1px solid #DDDDDD;
          padding: 20px 0;
          display: flex;
          .left{
            cursor: pointer;
            img{
              width: 137px;
              height: 196px;
            }
          }
          .middle{
            flex: 1;
            padding: 0 50px 0 15px;
            font-size: 14px;
            p{
              padding: 10px 0 0 0;
              margin: 0;
            }
            .p-name{
              color: #35353b;
              font-size: 16px;
              padding-top: 0;
            }
            .p-money{
              color: #de0024;
              font-weight: 600;
              font-size: 16px;
              span{
                font-weight: 200;
                text-decoration: line-through;
                color: #A2A2A2;
                font-size: 14px;
              }
            }
            .p-eBookPrice{
              color: #A2A2A2;
            }
            .star{
              margin-top: 10px;
            }
            .d-describe{
              margin-top: 10px;
              overflow: hidden;
              word-break: break-all;
              display: -moz-box;
              -moz-box-orient:vertical;
              display: -webkit-box;
              -webkit-box-orient:vertical;
              text-overflow: ellipsis;
              -webkit-line-clamp: 2;
            }
          }
          .right{
            display: flex;
            align-items:center;
            .btns{
              button{
                width: 100px;
                height: 28px;
                background-color: #B7151E;
                color: white;
                outline: none;
                border: 0;
                border-radius: 6px;
                cursor: pointer;
                float: right;
                margin-left: 15px;
              }
              img{
                padding: 0 10px;
                cursor: pointer;
              }
              .imgActive{
                cursor: auto;
              }
            }
          }
        }
        li:last-child{
          border: 0;
        }
      }
    }
    .no-data{
      padding: 0 0 20px 0;
      p{
        padding: 20px 0 0 0;
        margin: 0;
      }
      .p1{
        span{
          color: #B7151E;
        }
      }
      .p2{
        color: #666666;
        font-size: 14px;
      }
    }
  }
</style>
<style>
.el-pagination.is-background .el-pager li:not(.disabled).active{
    background: #B7151E !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Search/search.vue


// WEBPACK FOOTER //
// src/components/Search/search.vue